module.exports = {
  title: '移动端商品推荐',
  route: {
    path: '/content-manage',
    children: {
      path: 'app-recommend-goods-list',
    },
  },
};
